/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Inject, OnInit} from '@angular/core';
import {RemovalPoint} from '../../../_models/removal-point';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-removal-point-favorite',
  templateUrl: './dialog-removal-point-favorite.component.html',
  styleUrls: ['./dialog-removal-point-favorite.component.scss']
})
export class DialogRemovalPointFavoriteComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    public dialogRef: MatDialogRef<DialogRemovalPointFavoriteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RemovalPoint
  ) {
  }

  ngOnInit() {
    // This is intentional
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              LISTENERS                                                                                             ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public close(res: boolean): void {
    this.dialogRef.close(res);
  }

}
